import React, { Component } from 'react';
import { Button, Grid, Header, Icon, Label, Loader, Popup, Table } from 'semantic-ui-react';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import { toast, ToastContainer } from 'react-toastify';
import AddExamRecognition from './AddExamRecognition';
import axios from 'axios';
import moment from 'moment';

class RecognizedExams extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onButtonClick: false,
            addCourse: false,
            courses: [],
            loader: true,
            student: JSON.parse(localStorage.getItem('student')),
            newStudyProgram: JSON.parse(localStorage.getItem('newStudyProgram')),
            studyProgramSemesters: localStorage.getItem('studyProgramSemesters'),
            confirmation: false,
        };

        this.getExamRecognition = this.getExamRecognition.bind(this);
        this.deleteExamRecognition = this.deleteExamRecognition.bind(this);
    }

    componentDidMount() {
        this.getExamRecognition();
    }

    deleteExamRecognition(examId, optLock) {
        this.setState({ loader: true });
        let obj = {
            id: examId,
            optLock
        };
        axios.delete(`/student-study-program-exam-recognition/delete/${examId}/`, { data: obj })
            .then((res) => {
                this.setState({ loader: false, confirmation: false });
                toast('Uspješno ste izbrisali predmet!');
                this.getExamRecognition();
            }).catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Predmet nije izbrisan!');
            });
    }

    getExamRecognition() {
        if (!this.state.student.locked && this.state.student.dateOfAbandonment === null) {
            this.setState({ loader: true });
            axios.get(`/student-study-program-exam-recognition/${this.state.newStudyProgram.id}/`)
                .then(res => {
                    let courses = res.data;
                    this.setState({ courses, loader: false });
                });
        } else {
            this.setState({ loader: false });
        }
    }
    render() {
        return (
            <div>
                {!this.state.onButtonClick && !this.state.student.locked && this.state.student.dateOfAbandonment === null && this.state.newStudyProgram.semesterStudentStartsFrom !== null &&
                    <Button
                        floated="right"
                        icon
                        labelPosition="right"
                        color="blue"
                        size="small"
                        style={FiltersOnStyle}
                        onClick={() => { this.setState({ addCourse: true, onButtonClick: true }); window.scrollTo(0, 0); }}
                    ><Icon className="add" />
                        Dodavanje predmeta
                    </Button> }
                {!this.state.onButtonClick && <br />}

                {this.state.addCourse && <AddExamRecognition
                    getExamRecognition={this.getExamRecognition}
                    closeAddMode={() => this.setState({ addCourse: false, onButtonClick: false })}
                />}

                {(!this.state.student.locked && this.state.student.dateOfAbandonment === null) && <br/>}

                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.courses.length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Predmet
                                        <Header.Subheader>{this.state.student.studyProgramName}</Header.Subheader>
                                    </Header.Content>
                                </Header>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Priznaje se kao
                                        <Header.Subheader>{this.state.newStudyProgram.studyProgramName}</Header.Subheader>
                                    </Header.Content>
                                </Header></Table.HeaderCell>
                                <Table.HeaderCell>Semestar</Table.HeaderCell>
                                <Table.HeaderCell>Ocjena</Table.HeaderCell>
                                <Table.HeaderCell>Datum ocjene</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {this.state.courses.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {(index + 1)}.
                                </Table.Cell >
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="13">
                                                {el.previousCourseStudyProgram.courseBasic.name}
                                            </Grid.Column>
                                            <Grid.Column width="3" verticalAlign="middle" textAlign="right">
                                                {el.previousCourseInformation && <Popup content="Za ovaj predmet prikazuju se podaci sa starog plana." hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span><Icon name="check" color="blue" /></span></Label>} />}
                                                {/*<span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>*/}
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Table.Cell>
                                {/*<Table.Cell verticalAlign="middle" colSpan="2">*/}
                                {/*    {el.previousCourseStudyProgram.courseBasic.name}*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="13">
                                                {el.currentCourseStudyProgram !== null ? el.currentCourseStudyProgram.courseBasic.name : ''}
                                            </Grid.Column>
                                            <Grid.Column width="3" verticalAlign="middle" textAlign="right">
                                                {el.previousCourseInformation === false && <Popup content="Za ovaj predmet prikazuju se podaci sa novog plan." hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span><Icon name="check" color="blue" /></span></Label>} />}
                                                {/*<span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>*/}
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Table.Cell>
                                {/*<Table.Cell verticalAlign="middle" colSpan="2">*/}
                                {/*    {el.currentCourseStudyProgram !== null ? el.currentCourseStudyProgram.courseBasic.name : ''}*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell verticalAlign="middle">
                                    {el.studyProgramSemester.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.mark.displayName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {moment(el.date).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" >

                                    {this.state.confirmation === index ?
                                        <div>
                                            <h4>Jeste li sigurni?</h4>
                                            <Button.Group>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    onClick={() => { this.deleteExamRecognition(el.id, el.optLock); }}
                                                > DA</Button>
                                                <Button
                                                    basic="true"
                                                    color="red"
                                                    onClick={() => { this.setState({ confirmation: false }); }}
                                                >  NE

                                                </Button>
                                            </Button.Group></div>
                                        : <div>
                                            <Popup
                                                content="Brisanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.student.locked}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="tiny"
                                                        color="red"
                                                        onClick={() => this.setState({ confirmation: index })}
                                                    />}
                                            />
                                        </div>}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                        : <p>Nema unesenih podataka o priznatim predmetima za ovog studenta.</p>}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default RecognizedExams;



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/RecognizedExams.js